export const KAHL_AFTER_RELOAD_PROPERTY_KEY = 'reloadKahlKey';
// eslint-disable-next-line @typescript-eslint/no-var-requires
export const { Buffer } = require('buffer');
